export default {
    index: 0,
    plainclothes: false,
    auth: {
        isLogin: true,
        isDone: false,
    },
    resTableOption: {
        priceFirst: localStorage.getItem("res_tb_price_first") == 1 ? 1 : 0,
    },
    industry: [],
    category: {
        tmall: [],
    },
    customerService: {},
    ownActive: "order",
    profile: {
        name: "-",
        connect: {},
        attribute: {
            taxonomies: [],
        },
    },
};
